import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../helpers/auth.guard';
import { HttpErrorInterceptor } from '../helpers/http-error';
import { JwtInterceptor } from '../helpers/jwt.interceptor'
import { LoginComponent } from './login/login.component';
import { LoginLayoutComponent } from './layouts/login.layout';
import { HomeComponent } from './home/home.component';
import { HomeLayoutComponent } from './layouts/main.layout';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MovieComponent } from './movie/movie.component';
import { MovieTimingComponent } from './movietiming/movietiming.component';
import { WalletComponent } from './wallet/wallet.component';
import { RefferalComponent } from './refferal/refferal.component';
import { EventsComponent } from './events/events.component';


const routes: Routes = [
  {
    path: 'dashboard',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'movies',
        component: MovieComponent
      },
      {
        path: 'movietimings',
        component: MovieTimingComponent
      },
      {
        path: 'wallets',
        component: WalletComponent
      },
      {
        path: 'refferals',
        component: RefferalComponent
      },
      {
        path: 'events',
        component: EventsComponent
      }
    ]
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'login',
        component: LoginComponent
      }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/routing,module.ts